import moment from "moment-timezone";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SessionModel from "../../api/models/SessionModel";
import { useAuth, UserType } from "../../context/AuthContext";
import { getDuration, getRemainingTime } from "../../helpers/date_helpers";
import { composeStartTimeAndDate, openSessionInNewTab } from "./helper";
import TimeRemainingLabel from "./TimeRemainingLabel";
type ActiveSessionTimeStatusProps = {
  session: SessionModel;
  className?: string;
};
export default function ActiveSessionTimeStatus({
  session,
  className,
}: ActiveSessionTimeStatusProps) {
  const { t } = useTranslation();
  const authContext = useAuth();
  const LocalBasePath = "page.student.dashboard.room";
  let sessionTime = composeStartTimeAndDate(session.start_time!, session.date!);
  let textLabel = "";

  if (session.isInProgress) {
    textLabel = t(`${LocalBasePath}.enterSession`);
  } else if (sessionTime.isBefore(moment())) {
    // Session should have started but hasn't yet started by the tutor
    textLabel = t(`${LocalBasePath}.startingSoon`);
  } else {
    textLabel = t(`${LocalBasePath}.sessionStartSoon`, {
      time: getRemainingTime(sessionTime),
    });
  }

  const handleClickNavigation = () => {
    const userType = authContext?.userType as
      | UserType.Student
      | UserType.Candidate;
    if (session.isInProgress) openSessionInNewTab(userType)(session.id);
  };
  return (
    <TimeRemainingLabel
      className={className}
      onClick={handleClickNavigation}
      session={session}
    >
      {textLabel}
    </TimeRemainingLabel>
  );
}
